import React, { Fragment } from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  label?: string;
  tone?: 'light' | 'dark';
};
export function Countdown({
  label = 'The special offer ends in:',
  tone = 'light'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units: [number, string][] = [[hours, 'Hours'], [minutes, 'Minutes'], [seconds, 'Seconds']];
  const dark = tone === 'dark';
  return <div className="mt-7 flex flex-col items-center" role="timer" aria-label={label} data-id="element-69" data-mp="3h18wsvjcw88k">
      <p className={`flex items-center gap-2 text-xs font-bold uppercase tracking-wider ${dark ? 'text-sky' : 'text-navy'}`} data-id="element-70" data-mp="32483wopfi78i">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-71" data-mp="373uk970k03lj" />
        {label}
      </p>
      <div className="mt-3 flex items-start gap-2 sm:gap-3" data-id="element-72" data-mp="10c3httum245p">
        {units.map(([value, unit], i) => <Fragment key={unit} data-id="element-73" data-mp="15adbg00oswp7" data-mpi={i}>
            {i > 0 && <span className={`pt-4 font-display text-2xl font-bold sm:pt-5 ${dark ? 'text-white' : 'text-navy'}`} aria-hidden="true" data-id="element-74" data-mp="y16mhehpwdst">
                :
              </span>}
            <div className="flex flex-col items-center" data-id="element-75" data-mp="t094p30mdlru">
              <span className={`grid h-16 w-16 place-items-center rounded-xl font-display text-3xl font-bold tabular-nums shadow-lg sm:h-20 sm:w-20 sm:text-4xl ${dark ? 'bg-white text-navy' : 'bg-navy text-white'}`} data-id="element-76" data-mp="17poh1dzeloo0">
                {String(value).padStart(2, '0')}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wide ${dark ? 'text-white/70' : 'text-muted'}`} data-id="element-77" data-mp="o30m51bk7fq2">
                {unit}
              </span>
            </div>
          </Fragment>)}
      </div>
    </div>;
}